import type { FaireProductEntity } from "../../entity_types/product";

export const p_56smcdavz2: FaireProductEntity = {
  token: "p_56smcdavz2",
  type: "product",
  name: "Blue Congrats Grad Graduation Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/722c42be6e4dafccfa17cc4867ce46ba6a472468e9d75b35dd207a8522e9cc3e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/299d284d5b26f3f462be1ce095a78bd3ebcb5b05d78aedf9cf403c9f2301e8fd.webp",
    "https://cdn.faire.com/fastly/011dd03ec986a956df62aaf4b7dcbec1e3e2f5201bdf2c06b0e7ad549c4a64d6.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:41.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
